import { render, staticRenderFns } from "./ConsigneeInquiry.vue?vue&type=template&id=62a30dde&scoped=true&"
import script from "./ConsigneeInquiry.vue?vue&type=script&lang=js&"
export * from "./ConsigneeInquiry.vue?vue&type=script&lang=js&"
import style0 from "./ConsigneeInquiry.vue?vue&type=style&index=0&id=62a30dde&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62a30dde",
  null
  
)

export default component.exports